/* The campaign tile inside an editorial collection grid, kept against an edge.

   WHAT IT IS
   On the editorial category pages some cards in the product grid are campaign
   photos - product-card.editorial-grid-campaign - two columns wide, sometimes
   two rows tall. None of them are placed by hand: the grid auto-places each one
   after the cards that come before it, so where it ends up depends entirely on
   how many columns the row has.

   On FW26 two cards come first, so at four across the first campaign takes
   columns 3 and 4 and sits flush against the right edge, which is how it was
   designed. At six across the same two cards leave it on columns 3 and 4 of
   six - stranded in the middle with product columns on both sides, which reads
   as a mistake rather than as a campaign.

   WHAT THIS DOES
   It finds each tile's natural column and, if the tile is not already touching
   an edge, moves it to the nearer one. A tile sitting dead centre goes right.

   Moving one would leave a hole where it was, so the grid is switched to dense
   packing as soon as anything moves: the small cards that follow fall back into
   the gap instead of a blank rectangle appearing mid-row. A grid where every
   tile already sits on an edge is left completely alone, dense included, so its
   merchandised order is untouched.

   ONE TILE PER PASS
   Moving a tile reflows everything after it, so the first version measured all
   the tiles up front and then moved them - and every decision after the first
   was made against a layout that no longer existed. Four of the six tiles on
   FW26 were read as already being on an edge and left in the middle.

   So each pass measures the page as it stands, moves at most one tile, and
   measures again. It stops as soon as a pass finds nothing left to move, which
   is at most once per tile.

   WHY A SCRIPT AND NOT CSS
   CSS cannot ask where auto-placement put something. The column a tile lands on
   is a product of the column count and of how many cards happen to precede it,
   and both change - the column count with the VIEW BY toggle, the card count
   whenever the collection is re-merchandised. Measuring after the fact is the
   only way to get an answer that stays right.

   Everything is reset to its natural placement before each run, so this can run
   as often as it likes and always decides from scratch rather than from its own
   last answer.

   PHONES ARE LEFT ALONE
   Below the theme's 777px breakpoint the tiles carry span-s="row" and already
   run the full width, so there is no side for them to be on. Any placement
   applied on a wider screen is cleared on the way down. */
(function () {
    'use strict';

    var TILE = '.editorial-grid-campaign';
    var GRID = 'x-grid.product-grid';
    var DESKTOP = '(min-width: 777px)';

    function tracksOf(grid) {
        var style = window.getComputedStyle(grid);
        var tracks = style.gridTemplateColumns.split(' ').map(parseFloat);
        if (!tracks.length || isNaN(tracks[0])) { return null; }

        return {
            count: tracks.length,
            pitch: tracks[0] + (parseFloat(style.columnGap) || 0),
            left: grid.getBoundingClientRect().left + (parseFloat(style.paddingLeft) || 0)
        };
    }

    /* Which column a tile starts on, read off the page rather than guessed:
       the nearest track edge to where the browser actually put it. */
    function startColumn(tile, t) {
        var x = tile.getBoundingClientRect().left;
        var best = 0;
        var bestGap = Infinity;

        for (var i = 0; i < t.count; i++) {
            var gap = Math.abs((t.left + i * t.pitch) - x);
            if (gap < bestGap) { bestGap = gap; best = i; }
        }

        return best;
    }

    /* The first tile that is neither pinned already nor sitting on an edge. */
    function nextToMove(tiles, t) {
        for (var i = 0; i < tiles.length; i++) {
            var tile = tiles[i];
            if (tile.style.gridColumn) { continue; }

            var span = Math.round(tile.getBoundingClientRect().width / t.pitch) || 1;
            if (span >= t.count) { continue; }

            var start = startColumn(tile, t);
            var roomLeft = start;
            var roomRight = t.count - start - span;
            if (roomLeft === 0 || roomRight === 0) { continue; }

            return { tile: tile, span: span, left: roomLeft < roomRight };
        }

        return null;
    }

    function place(grid) {
        var tiles = grid.querySelectorAll(TILE);
        if (!tiles.length) { return; }

        var i;

        /* Always decide from the natural placement, never from last time's. */
        for (i = 0; i < tiles.length; i++) { tiles[i].style.gridColumn = ''; }
        grid.style.gridAutoFlow = '';

        if (!window.matchMedia(DESKTOP).matches) { return; }

        var dense = false;

        for (var pass = 0; pass < tiles.length + 1; pass++) {
            var t = tracksOf(grid);
            if (!t) { return; }

            var move = nextToMove(tiles, t);
            if (!move) { return; }

            /* Nearer edge wins; a tile sitting dead centre goes right. */
            move.tile.style.gridColumn = move.left
                ? ('1 / span ' + move.span)
                : ((-1 - move.span) + ' / -1');

            if (!dense) {
                grid.style.gridAutoFlow = 'row dense';
                dense = true;
            }
        }
    }

    function run() {
        var grids = document.querySelectorAll(GRID);
        for (var i = 0; i < grids.length; i++) { place(grids[i]); }
    }

    window.dicoPlaceCampaignTiles = run;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }

    window.addEventListener('load', run);
    document.addEventListener('shopify:section:load', run);

    var pending = null;
    window.addEventListener('resize', function () {
        if (pending) { window.clearTimeout(pending); }
        pending = window.setTimeout(function () { pending = null; run(); }, 150);
    });

    /* The density toggle changes the column count without touching the DOM, so
       there is nothing else to notice it. */
    document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-dico-density-toggle]')) {
            window.requestAnimationFrame(run);
            window.setTimeout(run, 120);
        }
    });

    if (window.MutationObserver) {
        var watched = document.getElementById('mainContent');
        if (watched) {
            var queued = null;
            new MutationObserver(function () {
                if (queued) { window.clearTimeout(queued); }
                queued = window.setTimeout(function () { queued = null; run(); }, 120);
            }).observe(watched, { childList: true, subtree: true });
        }
    }
}());